import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  NAVIGATE: COMMON_EVENT_NAMES.NAVIGATED,
  OPEN: "Open"
};
